const landingEn = {
  title1: 'Defining',
  title2: 'the digital future',
  subHeading: 'with AI assisted digital transformations',
  more: 'Learn more'
};

export default landingEn;
